import { components } from 'types/rest-schema';

export type AddSubjectObservationModel = components['schemas']['AddObservationModel'];
export type UpdateSubjectObservationModel = components['schemas']['UpdateSubjectObservationModel'];
export type DeleteSubjectObservationModel = components['schemas']['DeleteSubjectObservationModel'];
export type SubjectAssociationType = components['schemas']['SubjectAssociationType'];

export type SubjectObservationBulkUpdateDto = {
    observationIds: number[];
    closedDate: string | null;
    clearClosedDate: boolean;
    comments: string | null;
    ownerRef: string | null;
    rootCause: string | null;
};
export type SubjectObservations = components['schemas']['ObservationsDto'];

export enum SubjectObservationType {
    System = 0,
    Manual = 1,
    Note = 2,
}

export const SubjectAssociationTypes = {
    SubjectHub: 0 as SubjectAssociationType,
    SubjectProfile: 1 as SubjectAssociationType,
} as const;

export type SubjectObservationGridRow = {
    type: string;
    review_title: string | null;
    status: string;
    subject: string;
    obs_status_val: string; // just used for ordering
    review_log_created_for_latest_dataset: boolean | null;
    association: string;
    data_listing: string | null;
    data_listing_active: string | null;
    panel: string | null;
    panel_id: string | null;
    panel_active: string | null;
    panel_ref: string | null;
    observation_date: string;
    observation: string;
    owner_ref: string | null;
    owner_id: string | null;
    owner_name: string | null;
    owner_name_active: string | null;
    decision: string | null;
    review_log_id: string | null;
    decision_active: string | null;
    dataset_opened_on: string;
    dataset_id: string;
    reviews: string;
    open_actions: string;
    total_actions: string;
    recent_action: string | null;
    root_cause: string | null;
    comments: string | null;
    updated_date: string;
    closed_date: string | null;
    closed_date_populated_on: string | null;
    updated_by: string;
    created_date: string;
    created_by: string;
    record_id: string;
    is_deleted: string;
    is_latest: string;
    id: string;
    subject_review_log_created_for_latest_dataset: string | null;
    selected: boolean;
};
